// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__hsT4u","rootSmall":"AddTileButton_rootSmall__2C0wd"};